module.exports = __webpack_public_path__ + "img/shape-5.845d4425.png";